import emailjs from "emailjs-com";
import React, { useEffect, useRef } from "react";
import "./Contact.css";
import "aos/dist/aos.css";
import Aos from "aos";
import { Helmet } from "react-helmet";

export const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_9e2dj3u",
        "template_70dr5oq",
        form.current,
        "pSD_VSGMsfdx1NqoI"
      )
      .then(
        (result) => {
          alert("Message sent succesfully!! 👍");
        },
        (error) => {
          alert(error.message);
        }
      );
    e.target.reset();
  };

  return (
    <main>
      <Helmet>
        <title>Contact Nahal</title>
        <meta
          name="description"
          content="Contact me to plan a project together"
        />
      </Helmet>
      <div className="container py-5" data-aos="fade-up">
        <div className="screen">
          <div className="screen-header">
            <div className="screen-header-left">
              <div className="screen-header-button close"></div>
              <div className="screen-header-button maximize"></div>
              <div className="screen-header-button minimize"></div>
            </div>
            <div className="screen-header-right">
              <div className="screen-header-ellipsis"></div>
              <div className="screen-header-ellipsis"></div>
              <div className="screen-header-ellipsis"></div>
            </div>
          </div>
          <form ref={form} onSubmit={sendEmail}>
            <div className="screen-body">
              <div className="screen-body-item left">
                <div className="app-title">
                  <span>CONTACT</span>
                  <span>ME</span>
                </div>
                <a href="mailto:nahalanjun004@gmail.com" className="app-contact">
                  EMAIL: nahalanjun004@gmail.com
                </a>
              </div>
              <div className="screen-body-item">
                <div className="app-form">
                  <div className="app-form-group">
                    <input
                      className="app-form-control"
                      placeholder="NAME"
                      type="text"
                      autoFocus
                      required
                      name="name"
                    />
                  </div>
                  <div className="app-form-group">
                    <input
                      className="app-form-control"
                      placeholder="EMAIL"
                      type="email"
                      required
                      name="email"
                    />
                  </div>
                  <div className="app-form-group message">
                    <textarea
                      className="app-form-control"
                      placeholder="MESSAGE"
                      cols="30"
                      rows="8"
                      required
                      name="message"
                    ></textarea>
                  </div>
                  <div className="app-form-group buttons">
                    <button className="app-form-button border rounded">
                      SEND MENSSAGE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      ;
    </main>
  );
};

export default Contact;
